import React, { useState, useEffect } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import { InstitutionEditForm } from '../../components/institution/institution-edit-form';
import DashboardCard20 from '../../partials/dashboard/DashboardCard20';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from "react-router-dom";
import DashboardCard20physicians from '../../partials/dashboard/DashboardCard20physicians';
import { logAuditUI } from '../../utils/auditLogger';
// Define types for the user object
interface User {
  role: string;
  [key: string]: any; // For any additional properties
}

const EditInstitution: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
    const [user, setUser] = useState<User | null>(null);
    const token = localStorage.getItem('jwtToken');
    const location = useLocation();
        const { item: initialData } = location.state || {};
        const [selectedEdit, setSelectedEdit] = useState(initialData);
    

    useEffect(() => {
        if (selectedEdit) {
            logAuditUI({
                actionType: 'OPEN_FORM',
                module: 'Institutii medicale',
                entityType: 'institution',
                entityId: selectedEdit.institution_id,
                entityName: selectedEdit.description,
                description: `A deschis pagina instituției medicale: ${selectedEdit.description || selectedEdit.institution_id || ''}`,
            });
        }
    }, [selectedEdit]);

    useEffect(() => {
        //console.log(selectedEdit)
        if (token) {
            try {
                const decoded: User = jwtDecode(token);
                setUser(decoded);
            } catch (error) {
                console.error('Error decoding the token:', error);
            }
        }
    }, [token]);

    return (
        <div className="flex h-screen overflow-hidden">
            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto">
                {/* Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        {/* Dashboard actions */}
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">
                            {/* Left: Title */}
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
                                {user && user.role === 'Admin' ? "Editeaza institutia" : selectedEdit.description}
                                </h1>
                            </div>
                        </div>

                        <div className="w-full grid grid-cols-12 gap-4 justify-center">
                            {user && user.role === 'Admin' && (
                                <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full">
                                    <InstitutionEditForm />
                                </div>
                            )}

                            <div className={`${user && user.role !== "Admin" ? "col-span-12" : "col-span-12 xs:pb-10 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full"}`}>
                                <DashboardCard20 />
                            </div>

                            <div className={`${user && user.role !== "Admin" ? "col-span-12" : "col-span-12 xs:pb-10 w-full"}`}>
                                <DashboardCard20physicians />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default EditInstitution;